exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".sidebar{position:fixed;left:0;top:60px;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:200px;background:#f3f3f3}", "", {"version":3,"sources":["/divvit-app/client/components/Sidebar/client/components/Sidebar/style.styl","/divvit-app/client/components/Sidebar/style.styl"],"names":[],"mappings":"AAAA,SACE,eAAA,OACA,SACA,SACA,oBACA,aAAA,0BACA,sBAAA,YACA,kBACA,CCCD","file":"style.styl","sourcesContent":[".sidebar\n  position: fixed\n  left: 0\n  top: topbar-height\n  bottom: 0\n  display: flex\n  flex-direction: column\n  width: sidebar-width\n  background: awesome-blue\n",".sidebar {\n  position: fixed;\n  left: 0;\n  top: 60px;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  width: 200px;\n  background: #f3f3f3;\n}\n/*# sourceMappingURL=client/components/Sidebar/style.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??postcss!./node_modules/stylus-loader??ref--3-3!./client/components/Sidebar/style.styl
// module id = 471
// module chunks = 0